import './style.scss';

function ToggleSummaryPanel({ id, buttonText, children, className }: { id: string; buttonText: string; className?: string; children: React.ReactNode }) {
  return (
    <div id={id} className={`${className} border-bottom mb-0 px-3`}>
      <h3 className="m-0 collapsible-heading__item-heading collapsed">
        <button
          className="pt-3 pb-3 w-100 text-start btn--unstyled collapsed"
          data-bs-toggle="collapse"
          data-bs-target={`#${id}-collapsible-panel`}
          aria-expanded="false"
          aria-controls={`${id}-collapsible-panel`}
        >
          {buttonText}
        </button>
      </h3>
      <div id={`${id}-collapsible-panel`} className="collapsible-panel collapse">
        {children}
      </div>
    </div>
  );
}

export default ToggleSummaryPanel;
